import {useSpecialDaysQuery} from "@/components/special-days/queries.generated";
import {SpecialDay} from "@/api";

export type DataSource = {
    loading: boolean;
    days: SpecialDay[];
    refetch: () => void;
};

export function useDataSource(): DataSource {
    const query = useSpecialDaysQuery({fetchPolicy: "no-cache"});

    if (query.loading)
        return {
            loading: true,
            days: [],
            refetch: query.refetch,
        };

    return {
        loading: false,
        days: query.data.specialDays.items,
        refetch: query.refetch,
    };
}
